import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import ExternalLayout from '../../layout/External'
import { AUTH_USER_SECONDSIGNUP } from '../../redux/actions/actionTypes'

const RegisterSecond = () => {
  const form = useForm()

  const history = useHistory()

  const countries = [{ text: 'Venezuela', value: 'ven' }]

  const dispatch = useDispatch()

  const onSubmit = (values) => {
    dispatch({
      type: AUTH_USER_SECONDSIGNUP,
      payload: values,
    })
    history.push('/registro_tercero')
  }

  return (
    <ExternalLayout>
      <h1 className="font-bold text-2xl text-coolGray-900 mb-2 dark:text-white">
        Tu información personal
      </h1>

      <p
        className="font-normal text-sm mb-2 text-primary-700 dark:text-primary-200"
        style={{ opacity: 0.5 }}
      >
        Paso 2 de 5
      </p>

      <div className="w-96">
        <p className="font-normal text-gray-400 text-sm mb-2">
          Brindanos información para personalizar tu cuenta{' '}
        </p>
      </div>

      <Form form={form} onSubmit={onSubmit}>
        <FormItem
          classes="col-span-12 my-2"
          name="name"
          rules={{ required: 'Ingrese su nombre' }}
        >
          <InputText label="Nombre y Apellido" isUpperValue={false} />
        </FormItem>

        <FormItem
          classes="col-span-12 my-2"
          name="phone"
          rules={{
            pattern: {
              value: /^\d+$/,
              message: 'Solo se permiten números',
            },
            required: 'Ingrese su teléfono',
          }}
        >
          <InputText label="Teléfono" isUpperValue={false} />
        </FormItem>

        {/* <FormItem
          classes="col-span-12 my-2"
          name="businessName"
        >
          <InputText label="Razon Social" isUpperValue={false} />
        </FormItem> */}

        {/* <FormItem
          classes="col-span-12 my-2"
          name="country"
          rules={{ required: 'Ingrese su usuario' }}
          defaultValue={countries[0]}
        >
          <Select options={countries} label="Tipo" />
        </FormItem> */}

        {/* <FormItem
          classes="col-span-12 my-2"
          name="postalCode"
          rules={{ required: 'Ingrese su código postal' }}
        >
          <InputText label="Código Postal" isUpperValue={false} />
        </FormItem> */}

        <Button
          type="primary"
          classes="col-span-12 mt-6 font-semibold tracking-wide"
          htmlType="submit"
        >
          Continuar
        </Button>
      </Form>
    </ExternalLayout>
  )
}

export default RegisterSecond
